"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GalleryModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalleryModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
const Gallery_contracts_1 = require("./Gallery.contracts");
/**
 *
 * Component that contains a complete questionnaire needed to **EDIT** the `Gallery`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let GalleryModuleForm = GalleryModuleForm_1 = class GalleryModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.DashmixIconName = backoffice_1.DashmixIconName;
        this.moduleModes = _contracts_1.ModuleMode;
        this.variants = Gallery_contracts_1.GallerySelectionOptions;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = GalleryModuleForm_1.getInitialContent();
        /**
         * For smart pages enable option to select linked or find another
         */
        this.variant = Gallery_contracts_1.GallerySelectionOptions.Default;
    }
    get options() {
        const options = [{
                label: `${this.$t('forms.shared.selectionModes.default')}`,
                value: Gallery_contracts_1.GallerySelectionOptions.Default
            },
            {
                label: `${this.$t('forms.shared.selectionModes.auto')}`,
                value: Gallery_contracts_1.GallerySelectionOptions.Smart
            }];
        return options;
    }
    changeGalleryVariant(value) {
        this.variant = value;
        if (value === Gallery_contracts_1.GallerySelectionOptions.Smart) {
            this._content.gallery = { type: services_1.RelatedType.Gallery, value: '##GALLERY_ID##' };
            this._content.galleryType = Gallery_contracts_1.GallerySelectionOptions.Smart;
        }
        else {
            this._content.gallery = {};
            this._content.galleryType = Gallery_contracts_1.GallerySelectionOptions.Default;
        }
    }
    findGallerySource() {
        this.pickRelated(services_1.Picker.Gallery, this.setGallerySource);
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.Gallery,
            size: {
                colSpan: 2,
                rowSpan: 2,
                isResizable: true,
                minColSpan: 1,
                minRowSpan: 1,
                maxColSpan: 6
            },
            version: Gallery_contracts_1.GalleryVersion.Carousel
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            gallery: {},
            galleryType: Gallery_contracts_1.GallerySelectionOptions.Default
        };
    }
    get hasGallerySet() {
        return typeof this._content.gallery !== 'undefined' && this._content.gallery !== null && typeof this._content.gallery.value !== 'undefined';
    }
    /**
     * Options for the `<DashmixSelect name="version">`.
     */
    get versionOptions() {
        return Object.values(Gallery_contracts_1.GalleryVersion).map(version => ({
            label: this.$t(`forms.gallery.version.${version}`),
            value: version
        }));
    }
    /**
     * @inheritDoc
     * @override
     */
    afterInitialContentSetup() {
        this.$nextTick(() => {
            if (this.hasGallerySet) {
                this.describe(this._content.gallery);
            }
        });
    }
    setActiveVariant(related) {
        switch (related.value) {
            case '##GALLERY_ID##':
                this.variant = Gallery_contracts_1.GallerySelectionOptions.Smart;
                break;
            case -4:
                this.variant = Gallery_contracts_1.GallerySelectionOptions.Smart;
                break;
            default:
                this.variant = Gallery_contracts_1.GallerySelectionOptions.Default;
        }
    }
    setGallerySource(source) {
        if (!Object.prototype.hasOwnProperty.call(this._content, 'gallery')) {
            this._content = {
                ...this._content,
                gallery: source
            };
        }
        else {
            this._content.gallery = source;
        }
        this.describe(source);
    }
};
GalleryModuleForm = GalleryModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'GalleryModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixSelect: backoffice_1.DashmixSelect,
            FormErrors: form_2.FormErrors
        },
        mounted() {
            if (this._content.gallery) {
                this.setActiveVariant(this._content.gallery);
            }
        },
        template: `
    <div>
      <!-- Version (module variant) -->
      <div class="form-group">
        <label for="version">{{ $t('forms.shared.modulesVariant') }}</label>
        <DashmixSelect :model.sync="_version" name="version"
                       :options="versionOptions" :searchable="false" />
      </div>

      <div class="form-group">
        <div class="d-flex align-items-center mb-3" v-if="mode === moduleModes.Smart">
          <DashmixSelect :model="variant" @update:model="changeGalleryVariant" :options="options"/>
        </div>

        <div class="d-flex align-items-center" v-if="variant === variants.Default">
          <DashmixButton variant="alt" :icon="DashmixIconName.SearchSolid" :label="$t('forms.shared.search')"
                         @click="findGallerySource" />
          <p v-if="hasGallerySet" class="pl-3 m-0">
            <strong>{{ $t('forms.shared.chosenSource') }}</strong>&nbsp;&nbsp;{{ description(_content.gallery) }}
          </p>
        </div>

      </div>
      <!-- Form errors -->
      <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
    </div>
  `
    })
], GalleryModuleForm);
exports.GalleryModuleForm = GalleryModuleForm;
//# sourceMappingURL=Gallery.form.js.map